import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DisabledNetlifyIcon = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "28",
        viewBox: "0 0 32 28",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_4310_1583)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.64766 23.3027H8.34553L6.8374 21.8079V21.5085L9.14295 19.2234H10.7402L10.9532 19.4345V21.0176L8.64766 23.3027Z",
                        fill: "#5F6681"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M6.8374 6.39629V6.09684L8.34553 4.60205H8.64766L10.9532 6.88717V8.47031L10.7402 8.68141H9.14295L6.8374 6.39629Z",
                        fill: "#5F6681"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M20.1132 18.4848H17.9192L17.7359 18.3032V13.2126C17.7359 12.3069 17.3768 11.6049 16.2748 11.5803C15.7077 11.5656 15.0589 11.5803 14.3655 11.6073L14.2615 11.7129V18.3007L14.0783 18.4823H11.8842L11.7009 18.3007V9.60449L11.8842 9.42285H16.8221C18.7413 9.42285 20.2965 10.9643 20.2965 12.8665V18.3032L20.1132 18.4848Z",
                        fill: "#424960"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.9596 15.2252H0.183253L0 15.0436V12.864L0.183253 12.6824H8.9596L9.14286 12.864V15.0436L8.9596 15.2252Z",
                        fill: "#5F6681"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M31.8168 15.2252H23.0404L22.8572 15.0436V12.864L23.0404 12.6824H31.8168L32.0001 12.864V15.0436L31.8168 15.2252Z",
                        fill: "#5F6681"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M14.7346 6.70565V0.181631L14.9179 0H17.1169L17.3002 0.181631V6.70565L17.1169 6.88726H14.9179L14.7346 6.70565Z",
                        fill: "#5F6681"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M14.7346 27.7259V21.2019L14.9179 21.0203H17.1169L17.3002 21.2019V27.7259L17.1169 27.9075H14.9179L14.7346 27.7259Z",
                        fill: "#5F6681"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_4310_1583",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "32",
                        height: "28",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
export const ActiveNetlifyIcon = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "28",
        viewBox: "0 0 32 28",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_4310_3828)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.64766 23.3027H8.34553L6.8374 21.8079V21.5085L9.14295 19.2234H10.7402L10.9532 19.4345V21.0176L8.64766 23.3027Z",
                        fill: "#05BDBA"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M6.8374 6.39629V6.09684L8.34553 4.60205H8.64766L10.9532 6.88717V8.47031L10.7402 8.68141H9.14295L6.8374 6.39629Z",
                        fill: "#05BDBA"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M20.1135 18.4848H17.9194L17.7361 18.3032V13.2126C17.7361 12.3069 17.3771 11.6049 16.2751 11.5803C15.708 11.5656 15.0592 11.5803 14.3658 11.6073L14.2618 11.7129V18.3007L14.0785 18.4823H11.8844L11.7012 18.3007V9.60449L11.8844 9.42285H16.8224C18.7416 9.42285 20.2968 10.9643 20.2968 12.8665V18.3032L20.1135 18.4848Z",
                        fill: "#014847"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.9596 15.2252H0.183253L0 15.0436V12.864L0.183253 12.6824H8.9596L9.14286 12.864V15.0436L8.9596 15.2252Z",
                        fill: "#05BDBA"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M31.8166 15.2252H23.0402L22.8569 15.0436V12.864L23.0402 12.6824H31.8166L31.9998 12.864V15.0436L31.8166 15.2252Z",
                        fill: "#05BDBA"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M14.7344 6.70565V0.181631L14.9176 0H17.1167L17.2999 0.181631V6.70565L17.1167 6.88726H14.9176L14.7344 6.70565Z",
                        fill: "#05BDBA"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M14.7344 27.7259V21.2019L14.9176 21.0203H17.1167L17.2999 21.2019V27.7259L17.1167 27.9075H14.9176L14.7344 27.7259Z",
                        fill: "#05BDBA"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_4310_3828",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "32",
                        height: "28",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
export const NetlifyIconXS = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_237_2142)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M4.6835 12.4416H4.54057L3.8291 11.7301V11.5872L4.91603 10.5002H5.6691L5.76937 10.6005V11.3536L4.68243 12.4405L4.6835 12.4416Z",
                        fill: "#05BDBA"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M3.8291 4.39688V4.25395L4.54057 3.54248H4.6835L5.77043 4.62941V5.38248L5.67017 5.48275H4.9171L3.83017 4.39581L3.8291 4.39688Z",
                        fill: "#05BDBA"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.0905 10.1484H9.0558L8.9694 10.062V7.63958C8.9694 7.20865 8.7998 6.87478 8.28033 6.86305C8.0126 6.85558 7.70647 6.86305 7.38007 6.87585L7.331 6.92598V10.0609L7.2446 10.1473H6.20994L6.12354 10.0609V5.92331L6.20994 5.83691H8.53847C9.443 5.83691 10.1769 6.57078 10.1769 7.47531V10.062L10.0905 10.1484Z",
                        fill: "#014847"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M4.83102 8.59729H0.692357L0.605957 8.5109V7.4741L0.692357 7.3877H4.83102L4.91742 7.4741V8.5109L4.83102 8.59729Z",
                        fill: "#05BDBA"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M15.6098 8.59729H11.4712L11.3848 8.5109V7.4741L11.4712 7.3877H15.6098L15.6962 7.4741V8.5109L15.6098 8.59729Z",
                        fill: "#05BDBA"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.5542 4.54392V1.43992L7.6406 1.35352H8.6774L8.7638 1.43992V4.54392L8.6774 4.63032H7.6406L7.5542 4.54392Z",
                        fill: "#05BDBA"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.5542 14.5451V11.4411L7.6406 11.3547H8.6774L8.7638 11.4411V14.5451L8.6774 14.6315H7.6406L7.5542 14.5451Z",
                        fill: "#05BDBA"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_237_2142",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
export function NetlifyIcon(param) {
    let { isDisabled } = param;
    return isDisabled ? /*#__PURE__*/ _jsx(DisabledNetlifyIcon, {}) : /*#__PURE__*/ _jsx(ActiveNetlifyIcon, {});
}
